import React, { useState, useEffect } from 'react';
import { Menu } from 'antd';
import "./index.scss"
import { menu } from '../route-menu'
import { useNavigate, useLocation } from 'react-router-dom';

export default function HomeNav() {
    const navigate = useNavigate()
        , location = useLocation()
        , [selectedKeys, setSelectedKeys] = useState([location.pathname])


    // 监听路由变化并更新 selectedKeys
    useEffect(() => {
        const path = extractParentRoute(location.pathname)
        setSelectedKeys([path])

    }, [location.pathname]);


    const extractParentRoute = (pathname) => {
        const match = pathname.match(/^\/[^/]+/); // 使用正则表达式提取第一个非斜杠字符后的内容
        if (match) {
            return match[0];
        }
        return '/';
    }

    const onSelect = (e) => {
        const { domEvent, item, key } = e
        setSelectedKeys([key])
        navigate(key, { state: { title: domEvent.currentTarget.innerText, role: item.props.role } })
    }

    return (
        <div className='menu-container'>
            <Menu
                mode='horizontal'
                items={menu}
                onSelect={onSelect}
                selectedKeys={selectedKeys}
            />
        </div>
    )
}
